var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotEnjoyLifeWithDogV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M17.5 10C17.5 5.865 14.135 2.5 10 2.5C5.86417 2.5 2.5 5.86417 2.5 10",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M10 17.5C14.1358 17.5 17.5 14.135 17.5 10",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M2.5 10C2.5 14.1358 5.86417 17.5 10 17.5",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M12.7733 7.93333C12.6583 7.93333 12.565 8.02667 12.5658 8.14167C12.5658 8.25667 12.6592 8.35 12.7742 8.35C12.8892 8.35 12.9825 8.25667 12.9825 8.14167C12.9825 8.02667 12.8892 7.93333 12.7733 7.93333",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M7.19917 7.91667C7.08417 7.91667 6.99083 8.01 6.99167 8.125C6.99167 8.24 7.085 8.33333 7.2 8.33333C7.315 8.33333 7.40833 8.24 7.40833 8.125C7.40833 8.01 7.315 7.91667 7.19917 7.91667",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M7.08333 13.3333C7.08333 13.3333 8.1775 12.24 10 12.24C11.8233 12.24 12.9167 13.3333 12.9167 13.3333",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEnjoyLifeWithDogV1);
export default __webpack_public_path__ + "static/media/notEnjoyLifeWithDogV1.9a2ca0a2bda37ee7097c423fb34e2591.svg";
export { ForwardRef as ReactComponent };